import Tooltip from '@material-ui/core/Tooltip'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

const Icon = ({ visible, setValue }) => {
  const toggle = async (event) => {
    event.stopPropagation()
    setValue(!visible)
  }

  return visible
    ? <Tooltip title="Hide this facility on your profile" placement="top">
      <VisibilityIcon onClick={toggle} />
    </Tooltip>
    : <Tooltip title="Show this facility on your profile" placement="top">
      <VisibilityOffIcon onClick={toggle} />
    </Tooltip>
}

const FacilityVisibilityToggle = ({ facilityIndex, visible, setFieldValue }) => {
  const setValue = (value) => {
    setFieldValue(`facilities[${facilityIndex}].customData.visible`, value, false)
  }

  return <Icon visible={visible} setValue={setValue} />
}

export default FacilityVisibilityToggle
